<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { box-sizing: border-box; margin: 0; padding: 0; }
html,
body,
#app {
  min-height: 100%;
}
body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  background: #f0f0f0;
  overflow-y: auto;
}
</style>
